import { SHARE_FEEDBACK_LABEL_BY_VALUE } from '@/api/slack/internal/internal-slack.model';

const getLabel = (category: string) => {
    let label = SHARE_FEEDBACK_LABEL_BY_VALUE[category];
    if (label === 'Other') {
        label = 'feedback';
    }
    return label;
};

export { getLabel };
